import { centerDemoField } from 'components/cabinet/demo/center-field';
import React from "react";

import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandLess, ExpandMore } from '@vedmarket/ui-kit';
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";

import {COLORS} from "../../../../../../../config/constants";
import {useDemoExpandedInvoice} from 'components/cabinet/demo/steps/packaging/use-packaging';

import InvoiceSourceDocuments from '../document-import/invoice-source-documents';
import InvoiceTitle from "./components/invoiceTitle";
import InvoiceDetails from "./components/invoiceDetails";

import './invoice.scss';

const Invoice = ({openByDefault, invoice, index, testDriveScenarioSlug, onCloseInvoiceForm}: CalculatorInvoiceProps) => {

  const invoiceRef = React.useRef<HTMLDivElement>(null);

  const demoPlayback = useDemoExpandedInvoice(openByDefault)
  const [ isExpanded, setIsExpanded ] = React.useState(Boolean(openByDefault))
  const isInvoiceExpanded = demoPlayback.expanded ?? isExpanded
  const ExpandIcon = isInvoiceExpanded ? ExpandLess : ExpandMore

  const handleScroll = () => {
    requestAnimationFrame(() => {
      const invoiceElement = invoiceRef.current;
      if (invoiceElement && !centerDemoField(invoiceElement)) {
        invoiceElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  };

  const handleCloseInvoiceForm = () => {
    handleScroll();
    if (onCloseInvoiceForm) {
      onCloseInvoiceForm();
    }
  }
  return (
    <div className='invoice' ref={invoiceRef}>
      <Accordion sx={{
        marginBottom: 0,
        border: `1px solid ${COLORS.SLIGHTLY_GRAY}`,
        boxShadow: 'none',
      }}
      onChange={(_, expanded) => setIsExpanded(expanded)}
      {...demoPlayback}>
        <AccordionSummary
          expandIcon={<ExpandIcon style={{
            width: '24px',
            height: '24px',
            fill: 'currentColor',
          }}/>}
          sx={{
            padding: '23px',
            minHeight: '74px',
            '&.Mui-expanded': {
              minHeight: '74px',
            },
            '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
              margin: 0,
            },
            '& .MuiAccordionSummary-expandIconWrapper, & .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              color: COLORS.LIGHT_ACTION,
              alignSelf: 'flex-start',
              marginTop: '1px',
              transform: 'none',
            },
          }}
        >
          <InvoiceTitle invoice={invoice} index={index}/>

        </AccordionSummary>
        <AccordionDetails sx={{padding: 0}} className='invoice__details'>
          <InvoiceSourceDocuments invoiceId={invoice?.id} />
          <InvoiceDetails
            openByDefault={openByDefault}
            invoice={invoice}
            testDriveScenarioSlug={testDriveScenarioSlug}
            onCloseInvoiceForm={handleCloseInvoiceForm}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default Invoice
